












import { Component } from 'vue-property-decorator'
import { Chart } from 'highcharts-vue'
import { BaseQuestion } from '@/components/Survey/QuestionTypes/BaseQuestion'
import Tab from '@/components/Tabs/Tab.vue'
import Tabs from '@/components/Tabs/Tabs.vue'
import { TabData } from '@/components/Tabs/TabTypes'
import {
  generateMatrixSeries,
  SegmentTotalsRecord,
  getRankingTotals,
  getSegmentCount
} from '@/components/Survey/Utilities/ChartUtilities'
import { getOptionsTextFromQuestion } from '@/components/Survey/Utilities/SurveyUtilities'
import {
  slicedChartTooltipFormatter
} from '@/components/Survey/Utilities/ChartTooltipUtilities'
import SliceNotSupported from '@/components/Survey/SliceNotSupported.vue'

@Component({
  components: {
    Highcharts: Chart,
    Tabs,
    Tab,
    SliceNotSupported
  }
})
export default class RankDistributionQuestion extends BaseQuestion {
  get rankingTotals () {
    const categories = getOptionsTextFromQuestion(this.question).map(category => category.text)

    if (this.isVariant || this.isSliced) {
      return getRankingTotals(categories, this.typedSlicedResponses[this.selectedTab].map(response => response.answer))
    } else {
      return getRankingTotals(categories, this.indexResponses.map(response => response.answer))
    }
  }

  get rankingOrdinalTotals ():SegmentTotalsRecord {
    const rankingOrdianlsTotals:SegmentTotalsRecord = {}
    Object.keys(this.rankingTotals).forEach(category => {
      rankingOrdianlsTotals[category] = {}
      Object.keys(this.rankingTotals[category]).forEach(rankString => {
        const ordinal = this.ordinalTranlaste(rankString)
        rankingOrdianlsTotals[category][ordinal] = this.rankingTotals[category][rankString]
      })
    })

    return rankingOrdianlsTotals
  }

  get indexSeriesData () {
    const rankings = this.rankingTotals

    let series = generateMatrixSeries(
      rankings,
      this.rankNumbers,
      this.rankNumbers,
      { hasNaOpt: false, colors: this.colorConfiguration.divergentPalette.slice().reverse() }
    )

    series = series.map(s => {
      return { ...s, name: this.ordinalTranlaste(s.name!) }
    })

    return series
  }

  get generateChartOptions () {
    const options = {
      ...this.defaultChartOptions(this.categories),
      caption: {
        useHTML: true,
        text: this.captionText
      },
      yAxis: {
        ...this.defaultChartOptions(this.categories).yAxis,
        labels: {
          ...this.defaultChartOptions(this.categories).yAxis.labels,
          format: '{value}%'
        }
      },
      exporting: {
        ...this.defaultChartOptions(this.categories).exporting,
        chartOptions: {
          ...this.defaultChartOptions(this.categories).exporting.chartOptions,
          caption: {
            text: this.captionText
          }
        }
      },
      xAxis: {
        ...this.defaultChartOptions(this.categories).xAxis,
        categories: this.categories
      },
      series: this.indexSeriesData,
      tooltip: slicedChartTooltipFormatter(this.rankingOrdinalTotals, this.question.type + '-distributed', this.sliceByQuestion?.type)
    }

    return options
  }

  get rankNumbers () {
    const rankNumbers = this.question.options?.map((o, i) => (i + 1).toString()) || []
    return rankNumbers
  }

  get categories () {
    const categories = Object.keys(this.rankingTotals)
    return categories
  }

  get captionText () {
    return 'The Rank Distribution chart displays the percentage of participants who selected each rank position (1st, 2nd, 3rd, etc.) per item on the chart.'
  }

  get tabData (): TabData[] {
    return Object.entries(this.typedSlicedResponses).map(([key, responses]) => {
      return {
        title: key,
        segmentCount: getSegmentCount(this.typedSlicedResponses[key])
      }
    })
  }

  ordinalTranlaste (stringRank: string) {
    const ordinalMap:Record<string, string> = {
      1: '1st',
      2: '2nd',
      3: '3rd'
    }
    return ordinalMap[stringRank] || `${stringRank}th`
  }
}
